export default __webpack_public_path__ + "static/media/voter_id.4e525e27.csv";